import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
// const getCategoryItemsUrl = `${process.env.REACT_APP_API_URL}api/csa-app/filter`;

const getCategoryItemsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/filter`;




// Actions
const categoryItemsSuccess = data => ({
  type: types.CATEGORY_SUCCESS,
  data
});

const categoryItemsMoreSuccess = data => ({
  type: types.CATEGORY_MORE_SUCCESS,
  data
});

const categoryItemsRequested = () => ({
  type: types.CATEGORY_REQUEST
});

const categoryItemsFailure = error => ({
  type: types.CATEGORY_FAILURE,
  error
});


// API
export const getCategoryItems = (options) => {

  const val = {
    connection_id: options.connection_id,
    location: options.location,
    store_id: options.store_id,
    brand_code: options.brand_code,
    category_id: options.category_id,
    gender_id: options.gender_id,
    collection_id: options.collection_id,
    bar_code: options.bar_code,
    color_id: options.color_code,
    new_arrivals: options.new_arrivals,
    price_start_range: options.price_start_range,
    price_end_range: options.price_end_range,
    size_id: options.size_id,
    purity_id: options.purity_id,
    page: options.page,
    tenant_name: options.tenant_name
  };

  return dispatch => {

    dispatch(categoryItemsRequested());

    return axios.get(getCategoryItemsUrl, {
      params: { val }
    })
    .then(res => {

      if (res.data.ack === "Success") {
        dispatch(categoryItemsSuccess(res.data.results));
        return res.data.results;   // <-- return data
      } else {
        dispatch(categoryItemsFailure(res.data.status));
        return [];
      }

    });
  };
};

export const getMorecategoryItems = (options) => {
  
  return dispatch => {
    dispatch(categoryItemsRequested());
    axios.get(getCategoryItemsUrl, {
      params: {
        connection_id: options.connection_id,
        location: options.location,
        store_id: options.store_id,
        brand_code: options.brand_code,
        category_id: options.category_id,
        gender_id: options.gender_id,
        collection_id: options.collection_id,
        bar_code: options.bar_code,
        new_arrivals: options.new_arrivals,
        price_start_range: options.price_start_range,
        price_end_range: options.price_end_range,
        size_id: options.size_id,
        color_id: options.color_id,
        page: options.page
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(categoryItemsMoreSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(categoryItemsFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
